/**
 * Cookie utility for tracking lead form submissions.
 * Used to suppress exit intent popups after a user has already submitted a form.
 */

const LEAD_COOKIE_NAME = 'ihq_lead_submitted';
const DISMISS_COOKIE_NAME = 'ihq_exit_dismissed';
const COOKIE_DURATION_DAYS = 7;

/**
 * Set a cookie indicating a lead form was submitted.
 * Blocks exit intent for 12 months.
 */
export function setLeadSubmittedCookie(): void {
  if (typeof document === 'undefined') return;

  const expirationDate = new Date();
  expirationDate.setMonth(expirationDate.getMonth() + 12);

  document.cookie = `${LEAD_COOKIE_NAME}=true; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
}

/**
 * Check if the lead submitted cookie exists.
 */
export function hasLeadSubmittedCookie(): boolean {
  if (typeof document === 'undefined') return false;

  return document.cookie.split(';').some((item) => item.trim().startsWith(`${LEAD_COOKIE_NAME}=`));
}

/**
 * Set a cookie indicating the exit intent popup was dismissed.
 * Blocks exit intent for 7 days.
 */
export function setDismissedCookie(): void {
  if (typeof document === 'undefined') return;

  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + COOKIE_DURATION_DAYS);

  document.cookie = `${DISMISS_COOKIE_NAME}=true; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
}

/**
 * Check if the dismissed cookie exists.
 */
export function hasDismissedCookie(): boolean {
  if (typeof document === 'undefined') return false;

  return document.cookie.split(';').some((item) => item.trim().startsWith(`${DISMISS_COOKIE_NAME}=`));
}
